<template>
  <DxPopup
    :visible="popupVisible"
    :drag-enabled="false"
    :hide-on-outside-click="true"
    :show-title="true"
    title="Deliver To"
    @hidden="popupHidden"
    :showCloseButton="false"
    :width="550"
    :height="620"
  >
    <form>
      <DxForm
        :form-data="model"
        :read-only="false"
        :show-colon-after-label="false"
        :show-validation-summary="false"
        :validation-group="'edit-delivery-address-form'"
        :label-location="formsConfig.labelPosition"
        :customizeItem="customizeItem"
        :items="items"
        :show-required-mark="false"
        ref="delivery-address-form"
        @content-ready="onFormContentReady"
        :height="450"
      >
      </DxForm>
    </form>

    <div class="btn-footer">
      <DxButton
        text="Back"
        type="default"
        styling-mode="contained"
        @click="popupHidden"
      />
    </div>
  </DxPopup>
</template>

<script>
import validationEngine from "devextreme/ui/validation_engine";
import BaseViewMixin from "../../v1/_mixins/base.view";

export default {
  props: {
    setVisible: Boolean,
    callBack: {
      type: Function,
      default: function () {},
    },
    formModel: {
      type: Object,
      default: () => {},
    },
    CustomerCode: String,
    formItems: {
      type: Array,
      default: () => {},
    },
  },
  mixins: [BaseViewMixin],
  data() {
    return {
      model: this.formModel,
    };
  },
  async created() {},
  updated() {},
  watch: {
    setVisible: {
      // eslint-disable-next-line no-unused-vars
      handler: function (newVal, oldVal) {
        if (newVal) {
          this.$logger.trackEventOpenPopup("Edit Delivery Address");
        }
      },
    },
  },
  computed: {
    popupVisible() {
      return this.setVisible ? true : false;
    },
    items() {
      let items = [
        {
          itemType: "group",
          caption: "",
          colCount: 1,
          items: [
            {
              dataField: "DeliveryAddressCompanyName",
              validationRules: [
                {
                  type: "required",
                  message: "Delivery address is required",
                },
              ],
              editorType: "dxTextBox",
              editorOptions: {
                maxLength: 100,
                onFocusIn: (e) => {
                  var input = e.element.querySelector("input");
                  if (input) {
                    input.setAttribute(
                      "autocomplete",
                      "new-input-" + (e.name ? e.name : input.name)
                    );
                  }
                },
              },
              label: {
                text: "Name",
              },
            },
            {
              dataField: "DeliveryAddressStreetLine1",
              label: { text: "Street Line 1" },
              editorOptions: {
                maxLength: 50,
                onFocusIn: (e) => {
                  var input = e.element.querySelector("input");
                  if (input) {
                    input.setAttribute(
                      "autocomplete",
                      "new-input-" + (e.name ? e.name : input.name)
                    );
                  }
                },
              },
              validationRules: [
                {
                  type: "required",
                  message: "Street Line 1 is required",
                },
              ],
            },
            {
              dataField: "DeliveryAddressStreetLine2",
              label: { text: "Street Line 2" },
              editorOptions: {
                maxLength: 50,
                onFocusIn: (e) => {
                  var input = e.element.querySelector("input");
                  if (input) {
                    input.setAttribute(
                      "autocomplete",
                      "new-input-" + (e.name ? e.name : input.name)
                    );
                  }
                },
              },
            },
            {
              dataField: "DeliveryAddressSuburb",
              label: { text: "Suburb" },
              editorOptions: {
                maxLength: 50,
                onFocusIn: (e) => {
                  var input = e.element.querySelector("input");
                  if (input) {
                    input.setAttribute(
                      "autocomplete",
                      "new-input-" + (e.name ? e.name : input.name)
                    );
                  }
                },
              },
              validationRules: [
                {
                  type: "required",
                  message: "Suburb is required",
                },
              ],
            },
            {
              dataField: "DeliveryAddressState",
              label: { text: "State" },
              editorOptions: {
                maxLength: 50,
                onFocusIn: (e) => {
                  var input = e.element.querySelector("input");
                  if (input) {
                    input.setAttribute(
                      "autocomplete",
                      "new-input-" + (e.name ? e.name : input.name)
                    );
                  }
                },
              },
              validationRules: [
                {
                  type: "required",
                  message: "State is required",
                },
              ],
            },
            {
              dataField: "DeliveryAddressPostcode",
              label: { text: "Post Code" },
              editorOptions: {
                maxLength: 20,
                onFocusIn: (e) => {
                  var input = e.element.querySelector("input");
                  if (input) {
                    input.setAttribute(
                      "autocomplete",
                      "new-input-" + (e.name ? e.name : input.name)
                    );
                  }
                },
              },
              validationRules: [
                {
                  type: "required",
                  message: "Post Code is required",
                },
              ],
            },
            {
              dataField: "DeliveryAddressCountry",
              label: { text: "Country" },
              editorOptions: {
                maxLength: 30,
                onFocusIn: (e) => {
                  var input = e.element.querySelector("input");
                  if (input) {
                    input.setAttribute(
                      "autocomplete",
                      "new-input-" + (e.name ? e.name : input.name)
                    );
                  }
                },
              },
              validationRules: [
                {
                  type: "required",
                  message: "Country is required",
                },
              ],
            },
          ],
        },
      ];

      return this.formItems ? this.formItems : items;
    },
  },
  methods: {
    onFormContentReady(e) {
      if (e) validationEngine.validateGroup("edit-delivery-address-form");
    },
    popupHidden() {
      this.callBack();
    },

    onDeliveryAddressChanged(e) {
      if (e.itemData) {
        this.model.DeliveryAddressCompanyName = e.itemData.CompanyName;

        this.model.DeliveryAddressStreetLine1 =
          e.itemData.PhysicalAddressStreetLine1;
        this.model.DeliveryAddressStreetLine2 =
          e.itemData.PhysicalAddressStreetLine2;
        this.model.DeliveryAddressSuburb = e.itemData.PhysicalAddressSuburb;
        this.model.DeliveryAddressState = e.itemData.PhysicalAddressState;
        this.model.DeliveryAddressPostcode = e.itemData.PhysicalAddressPostcode;
        this.model.DeliveryAddressCountry = e.itemData.PhysicalAddressCountry;
        this.model.CustomerDeliveryAddressLineNo = e.itemData.LineNo.toString();
      }
    },
    customItemCreating(data) {
      if (!data.text) {
        data.customItem = null;
        return;
      }

      const newItem = {
        CompanyName: data.text,
        PhysicalAddressCountry: "",
        PhysicalAddressPostcode: "",
        PhysicalAddressState: "",
        PhysicalAddressStreetLine1: "",
        PhysicalAddressStreetLine2: "",
        PhysicalAddressSuburb: "",
      };

      data.customItem = newItem;
    },
  },
};
</script>

<style lang="scss">
// .gc-ed-address {
.btn-footer {
  display: flex;
  justify-content: flex-end;
  padding-top: 15px;
}
// }
</style>
